module.exports = __webpack_public_path__ + "static/foto-servicios-361ebca62b16d9d23ebe87d3bc0a6d7a.jpg";